import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit } from '@angular/core';
import {NextConfig} from '../../../../app-config';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit, AfterViewInit {
  public nextConfig: any;
  public menuClass: boolean;
  public collapseStyle: string;
  public windowWidth: number;
  public color : string;

  @Output() onNavCollapse = new EventEmitter();
  @Output() onNavHeaderMobCollapse = new EventEmitter();

  constructor() {
    this.nextConfig = NextConfig.config;
    this.menuClass = false;
    this.collapseStyle = 'none';
    this.windowWidth = window.innerWidth;
  }

  ngAfterViewInit() {
    // let element1 = document.getElementById("color1");
    // let element2 = document.getElementById("color2");
    // element1.style.backgroundColor = this.color;
    // element2.style.backgroundColor = this.color;
  }

  ngOnInit() {
    // let rol = localStorage.getItem('rol');
    // if( rol == "A" ){ this.color = "#63656a"; }
    // else if( rol == "C" ){ this.color = "#77498E"; }
    // else if( rol == "T" ){ this.color = "#E75967"; }
    // else if( rol == "E" ){ this.color = "#65174A"; }
  }

  toggleMobOption() {
    this.menuClass = !this.menuClass;
    this.collapseStyle = (this.menuClass) ? 'block' : 'none';
  }

  navCollapse() {
    if (this.windowWidth >= 992) {
      this.onNavCollapse.emit();
    } else {
      this.onNavHeaderMobCollapse.emit();
    }
  }

}
